import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import InputNumber from "./InputNumber"
import Field from "../Field"
import fieldSchemaPropTypes from "../fieldSchemaPropTypes"
import errorPropTypes from "../errorPropTypes"

function convertToNumber(value) {
  if (_.isNull(value) || _.isUndefined(value) || value === "") {
    return null
  }
  return Number(value)
}

export function NumberField(props) {
  const { className, error, id, label, labelId, name, schema, onChange, onBlur, touched, ...rest } =
    props

  const handleChange = e => {
    // making sure this value is always a number
    onChange(name, convertToNumber(e.target.value))
  }
  const handleBlur = e => {
    // making sure this value is always a number
    onBlur(name, convertToNumber(e.target.value))
  }

  return (
    <Field className={classNames("oj-number-field", className)} touched={touched} error={error}>
      <Field.Label id={labelId} inputId={id} label={label} required={schema.required}>
        <Field.Input {...schema} {...rest} id={id} error={error} name={name}>
          {innerProps => (
            <InputNumber {...innerProps} onChange={handleChange} onBlur={handleBlur} />
          )}
        </Field.Input>
      </Field.Label>
    </Field>
  )
}

NumberField.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape(errorPropTypes),
  id: PropTypes.string,
  label: PropTypes.node,
  labelId: PropTypes.string,
  name: PropTypes.string.isRequired,
  schema: PropTypes.shape(fieldSchemaPropTypes).isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  touched: PropTypes.bool
}

export default NumberField
